import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=52ce7f1e&scoped=true"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"
import style0 from "./manager.vue?vue&type=style&index=0&id=52ce7f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce7f1e",
  null
  
)

export default component.exports